import { render, staticRenderFns } from "./QueryAnswer.vue?vue&type=template&id=4cfaba26&scoped=true&"
import script from "./QueryAnswer.vue?vue&type=script&lang=js&"
export * from "./QueryAnswer.vue?vue&type=script&lang=js&"
import style0 from "./QueryAnswer.vue?vue&type=style&index=0&id=4cfaba26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfaba26",
  null
  
)

export default component.exports